export const IPMAT_CATEGORIES = ['GENERAL', 'NC_OBC', 'EWS', 'SC', 'ST', 'PWD'];

export function normalizeIPMATCategory(value) {
  if (!value) return null;
  const normalized = String(value).trim().toUpperCase().replace(/-/g, '_');
  return IPMAT_CATEGORIES.includes(normalized) ? normalized : normalized;
}

export function displayIPMATCategory(value) {
  const normalized = normalizeIPMATCategory(value);
  if (normalized === 'GENERAL') return 'General';
  if (normalized === 'NC_OBC') return 'NC-OBC';
  return normalized || '';
}
